import React from 'react';
import { SearchAddressApi } from '@/searchAddress/SearchAddressProvider.tsx';

// @ts-expect-errors
export const SearchAddressContext = React.createContext<SearchAddressApi>({});
